import { render, staticRenderFns } from "./medicamento-animal.vue?vue&type=template&id=271ca252"
import script from "./medicamento-animal.vue?vue&type=script&lang=js"
export * from "./medicamento-animal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports